import {TimelineFrameContentLabelledWrapper, timelineFrameContentLabels} from "./TimelineFrameContentLabelledWrapper";
import {TimelineFrameContentQuestionnairesWrapper} from "./content/segments/questionnaires/TimelineFrameContentQuestionnairesWrapper";
import TimelineFrameContentQuestionnaires from "./content/segments/questionnaires/TimelineFrameContentQuestionnaires";
import TimelineFrameContentInstructionsWrapper from "./content/segments/instructions/TimelineFrameContentInstructionsWrapper";
import TimelineFrameContentInstructions from "./content/segments/instructions/TimelineFrameContentInstructions";
import TimelineFrameContentCareUnitWrapper from "./content/segments/careunitdetails/TimelineFrameContentCareUnitWrapper";
import {TimelineFrameContentCareUnit} from "./content/segments/careunitdetails/TimelineFrameContentCareUnit";
import TimelineFrameContentDateTime from "./content/segments/appointment/default/TimelineFrameContentDateTime";
import TimelineFrameContentEventSpecificInfo from "./content/segments/appointment/default/TimelineFrameContentEventSpecificInfo";
import TimelineFrameContentVideoConference from "./content/segments/details/TimelineFrameContentVideoConference";
import TimelineFrameContentLocationWrapper from "./content/segments/location/TimelineFrameContentLocationWrapper";
import {TimelineFrameContentLocation} from "./content/segments/location/TimelineFrameContentLocation";
import {
    TimelineFrameContentAppointment
} from "./content/segments/appointment/TimelineFrameContentAppointment";
import {TimelineFrameContentFimlabDetails} from "./content/segments/details/TimelineFrameContentFimlabDetails";
import {TimelineFrameContentLabResearch} from "./content/segments/labresearch/TimelineFrameContentLabResearch";
import {
    TimelineFrameContentLabResearchWrapper
} from "./content/segments/labresearch/TimelineFrameContentLabResearchWrapper";
import {TimelineFrameContentDetails} from "./content/segments/details/TimelineFrameContentDetails";
import TimelineFrameContentDetailsWrapper from "./content/segments/details/TimelineFrameContentDetailsWrapper";

export const TimelineFrameContent = () => {
    return (
        <>
            <div className="ot-mainview" style={{boxShadow: "none"}}>

                <TimelineFrameContentAppointment />

                <TimelineFrameContentLocationWrapper>
                    <TimelineFrameContentLabelledWrapper label={timelineFrameContentLabels.LOCATION}
                                                         withHorizontalRule={true}>
                        <TimelineFrameContentLocation />
                    </TimelineFrameContentLabelledWrapper>
                </TimelineFrameContentLocationWrapper>


                <TimelineFrameContentDetailsWrapper>
                    <TimelineFrameContentLabelledWrapper label={timelineFrameContentLabels.DETAILS}
                                                         withHorizontalRule={true}>
                        <TimelineFrameContentDetails />
                    </TimelineFrameContentLabelledWrapper>
                </TimelineFrameContentDetailsWrapper>

                <TimelineFrameContentQuestionnairesWrapper>
                    <TimelineFrameContentLabelledWrapper label={timelineFrameContentLabels.QUESTIONNAIRES}
                                                         withHorizontalRule={true}>
                        <TimelineFrameContentQuestionnaires />
                    </TimelineFrameContentLabelledWrapper>
                </TimelineFrameContentQuestionnairesWrapper>

                <TimelineFrameContentInstructionsWrapper>
                    <TimelineFrameContentLabelledWrapper label={timelineFrameContentLabels.INSTRUCTIONS}
                                                         withHorizontalRule={true}>
                        <TimelineFrameContentInstructions />
                    </TimelineFrameContentLabelledWrapper>
                </TimelineFrameContentInstructionsWrapper>

                <TimelineFrameContentCareUnitWrapper>
                    <TimelineFrameContentLabelledWrapper label={timelineFrameContentLabels.CARE_UNIT_DETAILS}
                                                         withHorizontalRule={true}>
                        <TimelineFrameContentCareUnit />
                    </TimelineFrameContentLabelledWrapper>
                </TimelineFrameContentCareUnitWrapper>

                <TimelineFrameContentLabResearchWrapper>
                    <TimelineFrameContentLabelledWrapper label={timelineFrameContentLabels.LAB_RESEARCH}
                                                         withHorizontalRule={false}>
                        <TimelineFrameContentLabResearch />
                    </TimelineFrameContentLabelledWrapper>
                </TimelineFrameContentLabResearchWrapper>
            </div>
        </>
    );
};

